import type { ComponentType, MouseEvent } from "react";

import type { PostMetrics } from "@/hooks/usePostMetrics";
import BlogPostListItem, { type BlogPostListItemPost } from "./BlogPostListItem";

interface BlogPostListProps {
  posts: BlogPostListItemPost[];
  isAdmin: boolean;
  onPostClick: (post: BlogPostListItemPost) => void;
  onTogglePublish: (post: BlogPostListItemPost, event: MouseEvent) => void;
  onEditPost: (post: BlogPostListItemPost) => void;
  onDeletePost: (post: BlogPostListItemPost, event: MouseEvent) => void;
  onTagClick: (slug: string) => void;
  getMetrics: (postId: string) => PostMetrics | undefined;
  getSocialIcon: (platform: string) => string | ComponentType<{ className?: string }> | null;
  formatDate: (dateString: string) => string;
}

const BlogPostList = ({
  posts,
  isAdmin,
  onPostClick,
  onTogglePublish,
  onEditPost,
  onDeletePost,
  onTagClick,
  getMetrics,
  getSocialIcon,
  formatDate,
}: BlogPostListProps) => {
  return (
    <div className="space-y-4">
      {posts.map((post, index) => (
        <BlogPostListItem
          key={post.id}
          post={post}
          index={index}
          isAdmin={isAdmin}
          onPostClick={onPostClick}
          onTogglePublish={onTogglePublish}
          onEditPost={onEditPost}
          onDeletePost={onDeletePost}
          onTagClick={onTagClick}
          getMetrics={getMetrics}
          getSocialIcon={getSocialIcon}
          formatDate={formatDate}
        />
      ))}
    </div>
  );
};

export default BlogPostList;
